"use client";

// src/heading/heading-context.tsx
import { createContext } from "react";
var HeadingContext = createContext(0);

export {
  HeadingContext
};
